import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

app.initializers.add('wanecho/showfloor', () => {
  /**
 * 在评论创建后添加楼层信息。
 * @param {Vnode} vnode - 表示评论节点的 Vnode 对象。
 * @this {CommentPost}
 */
  extend(CommentPost.prototype, 'oncreate', function (vnode) {
    //显示楼层
    var index = this.element.parentNode.getAttribute('data-index');
    if (index > 0) {
      this.$('.Post-header').append("<div>" + index + "楼</div>")
    }
  });

});
